import { JSX, useEffect, useState } from "react";
import { handleSkipAndExit } from "../utils/handleSkipAndExit";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Button } from "../../../common/components/Button";
import { Cross } from "../../../common/svg/Cross";
import { setIsTimeoutModalOpen } from "../LeaveInformationSlice";

export const TimeoutModalContainer = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const { personInfo } = useAppSelector((state) => state.root);
    const [secondsLeft, setSecondsLeft] = useState(10);
    const navigate = useNavigate();

    useEffect(() => {
        if (secondsLeft <= 0) {
            handleSkipAndExit({
                personInfo,
                navigate,
            }).catch(console.error);
        }

        const timer = setTimeout(() => {
            setSecondsLeft((prev) => prev - 1);
        }, 1000);

        return () => clearTimeout(timer);
    }, [secondsLeft, navigate, personInfo]);

    return (
        <>
            <div className={"c-timeout-modal-backdrop"}></div>
            <div className={"c-timeout-modal"}>
                <div
                    className={"c-timeout-modal__cross"}
                    onClick={() => dispatch(setIsTimeoutModalOpen(false))}
                >
                    <Cross />
                </div>
                <div className={"c-timeout-modal__content"}>
                    <h1>Session timeout warning</h1>
                    <p>
                        It looks like you've been inactive for a while. You will
                        be automatically redirected in{" "}
                        <span>
                            {secondsLeft} second{secondsLeft !== 1 ? "s" : ""}.
                        </span>
                    </p>
                </div>
                <div className={"c-timeout-modal__footer"}>
                    <Button
                        type={"button"}
                        variant={"tertiary"}
                        onClick={() => dispatch(setIsTimeoutModalOpen(false))}
                    >
                        Continue filling out details
                    </Button>
                    <Button
                        type={"button"}
                        variant={"quaternary"}
                        onClick={() =>
                            handleSkipAndExit({
                                personInfo,
                                navigate,
                            })
                        }
                    >
                        Vote and exit
                    </Button>
                </div>
            </div>
        </>
    );
};
